import { render } from "./VoucherGroupListPage.vue?vue&type=template&id=2a8dc270&scoped=true"
import script from "./VoucherGroupListPage.vue?vue&type=script&lang=js"
export * from "./VoucherGroupListPage.vue?vue&type=script&lang=js"

import "./VoucherGroupListPage.vue?vue&type=style&index=0&id=2a8dc270&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a8dc270"

export default script